import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom';
import { USER_QUERY_KEY } from '../constants/queryKeys';
import { googleLogin } from "../services/auth-service";
import { useMemo } from 'react';
import { clearBuyNowItem, getBuyNowItem } from '../local_store/buyNowLocalStore';
import useAddToBuyNow from './useAddToBuyNow';
import { useWishlist } from '../contexts/WishlistContext';
import { useCart } from '../contexts/CartContext';
import { setStoredTokens } from '../local_store/userLocalStore';
import { getIntendedRoute, removeIntendedRoute } from '../local_store/intendedRouteLocalStore';
import { decryptData } from '../helpers/encryptor';

function useGoogleLogin() {
    const buyNowItem = useMemo(() => getBuyNowItem(), []);
    const { userAddToBuyNow } = useAddToBuyNow(buyNowItem?.productSlug ?? "");
    const navigate = useNavigate()
    const queryClient = useQueryClient();
    const { syncWishlist } = useWishlist(); // Get syncWishlist function
    const { syncCart } = useCart();
    const { mutateAsync: googleLogUserIn, isLoading, error, data } = useMutation({
        mutationFn: (loginData) => googleLogin(loginData),
        onSuccess: (data) => {
            const intendedRoute = getIntendedRoute();
            const accessToken = decryptData((data?.data?.data?.accessToken));
            const userId = decryptData(data?.data?.data?.id); // Assuming the user ID is in the response

            // Set tokens and user data
            setStoredTokens(data?.data?.data?.accessToken);
            queryClient.setQueryData([USER_QUERY_KEY], data?.data?.data);

            // Manually set the Authorization header for the Axios instance
            // API.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
            // Sync wishlist and cart
            if (userId && accessToken) {
                syncWishlist(userId, accessToken);
                syncCart(userId, accessToken);
                if (buyNowItem) {
                    userAddToBuyNow({ ...buyNowItem, userId, })
                    clearBuyNowItem()
                }
            }
            removeIntendedRoute()
            if (intendedRoute === "/") {
                navigate("/my-account")
            } else {
                navigate(intendedRoute)
            }
        },
        onError: (error) => {
            // return error
        }
    })
    return {
        googleLogUserIn, isLoading, error, data
    }
}

export default useGoogleLogin